<template>
  <div class="verify-guide-dialog">
    <md-popup
      v-model="dialogVisible"
      @hide="hideDialog"
    >
      <div class="icon">
        <img src="@/assets/image/icons/icon-warning.svg">
      </div>
      <div class="text">
        {{ text }}
      </div>
      <div class="button">
        <md-button type="primary" round @click="goVerify">
          {{ $t('doItNow') }}
        </md-button>
      </div>
      <div class="button">
        <md-button type="primary" plain round @click="hideDialog">
          {{ $t('later') }}
        </md-button>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Popup } from 'mand-mobile'

import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        text: 'Your total balance exceed Rp 1.000.000 You have to complete onboarding process first',
        withdrawText: 'To withdraw money you have to complete onboarding process first',
        doItNow: 'Do it now',
        later: 'Later',
      },
      id: {
        text: 'Your total balance exceed Rp 1.000.000 You have to complete onboarding process first',
        withdrawText: 'Untuk menarik nominal silahkan mengisi akun bank terlebih dahulu',
        doItNow: 'Lakukan sekarang',
        later: 'Nanti',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  mixins: [dialogMixins],
  props: {
    isWithdraw: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      return this.isWithdraw ? this.$t('withdrawText') : this.$t('text')
    },
  },
  methods: {
    goVerify() {
      this.$router.push({ name: 'SignupAdditional' })
    },
  },

}
</script>

<style scoped lang="stylus">
.verify-guide-dialog /deep/ {
  .md-popup-box {
    width: 90%;
    padding: 60px 30px 30px;
    background-color: #fff;
    border-radius: 6px;
  }
  .icon {
    text-align: center;
    margin-bottom: 25px;
    img {
      width: 46px;
      height: 46px;
    }
  }
  .text {
    text-align: center;
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 1.25em;
    font-weight: bold;
  }
  .button .md-button {
    margin-bottom: 15px;
    border-radius: 20px;
  }
}
</style>
